import { Height } from "@mui/icons-material";

export const text_field_styles = {
  margin: "10px 0",
  width: "100%",
  backgroundColor: "#F7FAFC",
  border: "none",
  "& label": {
    color: "#2A4365",
    fontWeight: "bold",
  },
  "& fieldset": {
    border: "none!important",
  },
  "& .MuiInputBase-root": {
    color: "#2A4365",
  },
};

export const data_grid_styles = {
  padding: "10px",
  border: "none!important",
  "& .MuiDataGrid-virtualScrollerContent": {
    // height: "max-content!important",
  },
  "& .MuiDataGrid-columnHeaders": {
    "& > div": {
      "& > div": {
        border: "none!important",
      },
    },
  },
  "& .MuiDataGrid-columnHeader": {
    border: "none!important",
  },
  "& .MuiDataGrid-filler": {
    border: "none!important",
  },
  "& .MuiDataGrid-scrollbarFiller": {
    border: "none!important",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: "#2A4365",
    fontWeight: "bold",
  },
  "& .MuiDataGrid-row": {
    height: "80px!important",
    minHeight: "80px!important",
    backgroundColor: "#F7FAFC",
    margin: "4px 0",
    borderRadius: "10px",
  },
  "& .MuiDataGrid-cell": {
    padding: "10px",
    color: "#2A4365",
    height: "80px!important",
    minHeight: "80px!important",
    border: "none!important",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiDataGrid-cellEmpty": {
    display: "none",
  },
  "& .MuiTablePagination-root": {
    color: "#2A4365",
  },
};
